import Vue from 'vue/dist/vue.js';
import {
  Select, Option, Input
} from 'element-ui';
import axios from 'axios';

const config = Object.assign({}, window.erpPortalApiConfig);
if (localStorage.getItem('erpPortalApiAuthToken')) {
  config.headers = config.headers || {};
  config.headers.Authorization = `Bearer ${localStorage.getItem('erpPortalApiAuthToken')}`;
}
const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

_axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.response.status == 401) {
      localStorage.removeItem('erpPortalApiAuthToken');
      localStorage.setItem('erpPortalApiAuthReturnUrl', window.location.href);
      setTimeout(() => window.location.href = '/signin', 3000);
      error.response.data.error = 'Unauthorized. Redirecting...';
    }

    return Promise.reject(error);
  }
);

export default () => {
  apos.util.widgetPlayers['catalog-filters'] = {
    selector: '[data-catalog-filters-widget]',
    player: function(el) {
      if (el.dataset.multi === 'true') {
        const SelectCD = Vue.component('multi-select-cd', {
          components: {
            'el-select': Select,
            'el-option': Option,
            'el-input': Input
          },
          template: `
            <el-select
                    v-model="selectValue"
                    multiple
                    value-key="value"
                    style="width: 85%;"
                    name="cd"
                    no-data-text="No Data"
                    @change="handleChange"
                    placeholder="">
                <el-option
                        v-for="item in options"
                        class="catalog-filter-picklist--option"
                        :key="item.value"
                        :label="item.value"
                        :value="item">
                </el-option>
            </el-select>
    `,
          data: function () {
            return {
              selectValue: [],
              options: []
            };
          },
          created() {
            window.globalCDValues = [];
            this.getConditionList();
          },
          methods: {
            handleChange() {
              window.globalCDValues = this.selectValue;
            },
            async getConditionList() {
              const response = await _axios({
                method: 'GET',
                url: '/v1/catalog/get-conditions',
                params: {
                  cid: window.erpPortalApiCompany
                }
              });
              this.options = response.data.data.conditions;
              this.resolveQueryFilter();
            },
            resolveQueryFilter() {
              const urlParams = new URLSearchParams(window.location.search);
              if (urlParams.get('cd')) {
                this.selectValue = this.options.filter(cd =>
                  urlParams.get('cd').split(',').includes(cd.value)
                );
              }
            }
          }
        });
        new Vue(SelectCD).$mount('#multi-select-cd');
      }

      if (el.dataset.name === 'oem') {
        const SelectOem = Vue.component('select-oem', {
          components: {
            'el-select': Select,
            'el-option': Option,
            'el-input': Input
          },
          template: `
            <el-select
                    v-model="selectValue"
                    style="width: 85%;"
                    name="oem"
                    filterable
                    no-data-text="No Data"
                    no-match-text="No Data"
                    @change="handleChange"
                    placeholder="">
                <el-option
                        v-for="item in options"
                        class="catalog-filter-picklist--option"
                        :key="item"
                        :label="item"
                        :value="item">
                </el-option>
            </el-select>
    `,
          data: function () {
            return {
              selectValue: [],
              options: []
            };
          },
          created() {
            window.globalOEMValues = null;
            this.getPicklists();
          },
          methods: {
            handleChange() {
              window.globalOEMValues = this.selectValue;
            },
            async getPicklists() {
              const response = await _axios({
                method: 'GET',
                url: '/v1/picklist/get',
                params: {
                  cid: window.erpPortalApiCompany,
                  name: 'oem_list'
                }
              });
              this.options = response.data.data;
              this.resolveQueryFilter();
            },
            resolveQueryFilter() {
              const urlParams = new URLSearchParams(window.location.search);
              if (urlParams.get('pn_oem')) {
                this.selectValue = urlParams.get('pn_oem');
                window.globalOEMValues = urlParams.get('pn_oem');
              }
            }
          }
        });
        new Vue(SelectOem).$mount('#select-oem');
      }
      if (el.dataset.name === 'ac model') {
        const ACMOdel = Vue.component('select-ac-model', {
          components: {
            'el-select': Select,
            'el-option': Option,
            'el-input': Input
          },
          template: `
            <el-select
                    v-model="selectValue"
                    style="width: 85%;"
                    name="ac_model"
                    filterable
                    no-data-text="No Data"
                    no-match-text="No Data"
                    @change="handleChange"
                    placeholder="">
                <el-option
                        v-for="item in options"
                        class="catalog-filter-picklist--option"
                        :key="item"
                        :label="item"
                        :value="item">
                </el-option>
            </el-select>
    `,
          data: function () {
            return {
              selectValue: [],
              options: []
            };
          },
          created() {
            window.globalACModelValues = null;
            this.getPicklists();
          },
          methods: {
            handleChange() {
              window.globalACModelValues = this.selectValue;
            },
            async getPicklists() {
              const response = await _axios({
                method: 'GET',
                url: '/v1/picklist/get',
                params: {
                  cid: window.erpPortalApiCompany,
                  name: 'ac_model'
                }
              });
              this.options = response.data.data;
              this.resolveQueryFilter();
            },
            resolveQueryFilter() {
              const urlParams = new URLSearchParams(window.location.search);
              if (urlParams.get('pn_ac_model')) {
                this.selectValue = urlParams.get('pn_ac_model');
                window.globalACModelValues = urlParams.get('pn_ac_model');
              }
            }
          }
        });
        new Vue(ACMOdel).$mount('#select-ac-model');
      }
    }
  };
};
